import { render, staticRenderFns } from "./DeliveryRecordDetail.vue?vue&type=template&id=4058cc2c&scoped=true&"
import script from "./DeliveryRecordDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryRecordDetail.vue?vue&type=style&index=0&id=4058cc2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058cc2c",
  null
  
)

export default component.exports